import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {FormLayout, ObjectSelect2, Panel} from 'shared/components';

const Approvers = observer(({uiState}) => {
  const {policy, availableApprovers, errors} = uiState;

  return (
    <>
      <Panel.Header
        title={t('expenses.manage.policies.edit.Approvers')}
        description={t('expenses.manage.policies.edit.Choose the users that will be assigned to approving expense requests for employees in this policy.')}
      />
      <FormLayout>
        <ObjectSelect2
          by='value'
          value={policy.approvers}
          items={availableApprovers}
          onAdd={approver => policy.addApprover(approver)}
          onRemove={approver => policy.removeApprover(approver)}
          errorMessage={errors.approvers}
          multiple
          searchable
        />
      </FormLayout>
    </>
  );
});

export default Approvers;
